import actionTypes from '../constants/action-types';
import globals from '../../globals';
import hdrm from '../../hdrm';
import site from '../../site';
import prepareSerializedStaticDocument from '../../hdrm/utils/helpers/prepare-serialized-static-document';

const bulkPageChanges = (store) => (next) => (action) => {
  if (action.type === actionTypes.BULK_VIEW_ACTIONS) {
    const { strategy } = action.payload.options;
    if (strategy !== hdrm.constants.updateStrategies.UPDATE_LIVE_ONLY) {
      const state = store.getState();
      const activePageId = site.selectors.getActivePageId(state);
      const clonedStaticDOM = hdrm.instance.driver.getStaticDocument().cloneNode(true);
      const newHTML = prepareSerializedStaticDocument(clonedStaticDOM);
      const { globalsToUpdate } = action.payload;

      globals.helpers.saveGlobals(globalsToUpdate);

      store.dispatch(site.actions.setPageHTML(activePageId, newHTML));
    }
  }

  next(action);
};

export default bulkPageChanges;
